import React, { useState } from 'react'
import { 
    ContCard, 
    ContDataInfoTitle, 
    BtnSelectCard, 
    CardMeta, 
    MetaItem, 
    StatusBadge 
} from '../../../../../../../assets/css/components/admin/marketplace-to-marketplace/cardItem/CardItemStyle'
import CardContImage from './CardContImage';
import MenuCard from './MenuCard';
import { BiBarcode, BiHash, BiCheckShield, BiDollar, BiBox } from 'react-icons/bi';

function CardOdooProd({currentThirdPartyUser, active, data, addItemToSend, pluginSearch, findByThatCat}) {
    const [showMenu, setShowMenu] = useState(false);

    return (
        <ContCard>
            <CardContImage urlImage={data.thumbnail} dataIconInfo={data} setShowMenu={setShowMenu} pluginSearch={pluginSearch} />
            
            <ContDataInfoTitle title={data.title}>
                {data.title}
            </ContDataInfoTitle>

            <CardMeta>
                {data.authorizeds?.includes(currentThirdPartyUser._id) && (
                    <div style={{marginBottom: '8px'}}>
                        <StatusBadge variant="success">
                            <BiCheckShield style={{marginRight: 4}}/> Autorizado
                        </StatusBadge>
                    </div>
                )}

                <MetaItem>
                    <span className="label"><BiBarcode /> Cod Bar:</span>
                    <span className="value" title={data.barCode}>{data.barCode || '-'}</span>
                </MetaItem>

                <MetaItem>
                    <span className="label"><BiHash /> Ref Int:</span>
                    <span className="value" title={data.sku}>{data.sku || '-'}</span>
                </MetaItem>

                <MetaItem>
                    <span className="label"><BiDollar /> Precio:</span>
                    <span className="value">{data.price || '-'}</span>
                </MetaItem>

                <MetaItem>
                    <span className="label"><BiBox /> Stock:</span>
                    <span className="value">{data.stock || 0}</span>
                </MetaItem>
            </CardMeta>

            {pluginSearch !== 'py' && (
                <BtnSelectCard active={active} onClick={() => addItemToSend(data)}>
                    {active ? 'Remover' : 'Seleccionar'}
                </BtnSelectCard>
            )}

            <MenuCard active={showMenu} setActive={setShowMenu} data={data} pluginSearch={pluginSearch} findByThatCat={findByThatCat} />
        </ContCard>
    )
}

export default React.memo(CardOdooProd);

